import { render, staticRenderFns } from "./AddMaterialLink.vue?vue&type=template&id=fc8e5a7c&scoped=true"
import script from "./AddMaterialLink.vue?vue&type=script&lang=js"
export * from "./AddMaterialLink.vue?vue&type=script&lang=js"
import style0 from "./AddMaterialLink.vue?vue&type=style&index=0&id=fc8e5a7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8e5a7c",
  null
  
)

export default component.exports